import { Api } from "../Api/Api";

//login api
export const loginApi =(data)=> Api.post('api/login',data,{headers:{Platform :'Web'}});

